import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', path: '/#about', external: false },
    { name: 'Experience', path: '/#experience', external: false },
    { name: 'Skills', path: '/#skills', external: false },
    { name: 'Projects', path: '/#projects', external: false },
    { name: 'Github', path: '/#github-projects', external: false },
    { name: 'Blog', path: 'https://mytech.ravikishan.in/', external: true },
    { name: 'Contact', path: '/#contact', external: false }
  ];

  return (
    <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        padding: scrolled ? '1rem 2rem' : '1.5rem 2rem',
        background: scrolled ? 'rgba(10, 15, 30, 0.8)' : 'transparent',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255, 255, 255, 0.05)' : 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.3s ease'
      }}
    >
      <Link 
        to="/" 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{ textDecoration: 'none', color: '#fff', fontSize: '1.5rem', fontWeight: 800, letterSpacing: '1px' }}
      >
        RK<span style={{ color: 'var(--accent-cyan)' }}>.</span>
      </Link>
      
      <div className="nav-links">
        {navLinks.map((link, idx) => {
          const styleProps = {
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            fontSize: '0.95rem',
            fontWeight: 500,
            transition: 'color 0.3s ease',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          };
          
          if (link.external) {
            return (
              <a 
                key={idx} 
                href={link.path}
                target="_blank"
                rel="noreferrer"
                style={styleProps}
                onMouseEnter={(e) => e.target.style.color = 'var(--accent-cyan)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                {link.name}
              </a>
            );
          }
          
          return (
            <HashLink 
              key={idx} 
              smooth
              to={link.path}
              style={styleProps}
              onMouseEnter={(e) => e.target.style.color = 'var(--accent-cyan)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
            >
              {link.name}
            </HashLink>
          );
        })}
      </div>
    </motion.nav>
  );
};

export default Navbar;
